import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { portfolioItems } from '../data';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiExternalLink, FiStar } = FiIcons;
const TELEGRAM_LINK = "https://t.me/sc4apps";
const AD_IMAGE = "https://media-manager-c.questera.ai/greta-media/68006fc6df68f4f5bc01821949a2b884eb60ba200c31511c30383c26a273083ae6231f67b9f8b3bd44d287de01256011/images/aW1hZ2UvcG5n/ba0595ec39fba999ad915de9f386d4be.png";

const Home = () => {
  return (
    <main className="pt-20">
      {/* Portfolio Section */}
      <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto">
        <motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.6}} className="mb-16 text-center">
          <h1 className="text-4xl md:text-6xl font-black tracking-tight text-white mb-6 uppercase">Our Portfolio</h1>
          <div className="h-1.5 w-24 bg-yellow-500 mx-auto rounded-full"></div>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item,idx) => (
            <React.Fragment key={item.title}>
              <motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.5,delay: idx * 0.05}} className="group relative flex flex-col bg-[#111113] border border-white/5 rounded-3xl overflow-hidden hover:border-yellow-500/40 transition-all duration-500 hover:shadow-[0_0_40px_-10px_rgba(234,179,8,0.15)]">
                {item.isNew && (
                  <div className="absolute top-4 right-4 z-20">
                    <div className="bg-yellow-500 text-black text-[10px] font-black px-3 py-1 rounded-full flex items-center gap-1 shadow-lg animate-pulse">
                      <SafeIcon icon={FiStar} className="text-xs" /> NEW RELEASE
                    </div>
                  </div>
                )}
                <div className="aspect-video w-full overflow-hidden bg-black/50 relative">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" loading="lazy" />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <SafeIcon icon={FiExternalLink} className="text-yellow-500 text-3xl" />
                  </div>
                </div>
                <div className="p-8 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-white mb-8 group-hover:text-yellow-500 transition-colors uppercase tracking-tight">{item.title}</h3>
                  <div className="mt-auto">
                    <a href={TELEGRAM_LINK} target="_blank" rel="noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black font-black py-4 px-4 rounded-2xl transition-all duration-300 uppercase tracking-widest text-xs shadow-lg shadow-yellow-500/10">
                      ORDER NOW <SafeIcon icon={FiArrowRight} className="text-lg" />
                    </a>
                  </div>
                </div>
              </motion.div>
              {idx === 5 && (
                <Link to="/advert-guide" aria-label="View the advert guide" className="col-span-full block overflow-hidden rounded-2xl bg-[#0D0D0D] ring-1 ring-white/10 hover:ring-yellow-500/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-all">
                  <img src={AD_IMAGE} alt="Linkacode Vizi Player offer for iPhone and iPad: 30% off with code SC4APPS30. Click for the guide." className="block w-full h-auto" loading="lazy" />
                </Link>
              )}
            </React.Fragment>
          ))}
        </div>
      </section>
      {/* About Section */}
      <section className="py-24 bg-[#111113] border-y border-white/5">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-invert prose-lg max-w-none">
            <p className="text-slate-200 leading-relaxed mb-6 text-xl font-medium">
              At SC4APPS,we specialise in bespoke app development and graphic design. Our team brings together an expert digital technician managing all technical and panel-related work,alongside an award-winning graphic designer with over 15 years of industry experience.
            </p>
            <p className="text-slate-400 leading-relaxed mb-6">
              Whether you choose one of our existing app designs or need something built entirely from scratch — we'll tailor everything to your exact specifications,completely free of charge. Want a specific footballer as your icon,or a fully custom app right down to the settings button? We handle it all for one simple,flat fee.
            </p>
            <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-2xl p-8 mb-12 text-center">
              <a href={TELEGRAM_LINK} target="_blank" rel="noreferrer" className="text-yellow-500 font-black hover:text-yellow-400 transition-colors flex items-center justify-center gap-3 text-2xl tracking-tight">
                📲 Telegram: {TELEGRAM_LINK}
              </a>
            </div>
            <div className="bg-black/50 p-10 rounded-3xl border border-white/5 mb-16 shadow-2xl">
              <h4 className="text-yellow-500 font-black mb-6 tracking-widest text-xs uppercase">DISCLAIMER</h4>
              <p className="text-slate-400 text-sm leading-relaxed">
                SC4APPS does not host,sell,or distribute any IPTV or live TV streams. Please ensure you are aware of and comply with all applicable streaming laws in your country. We accept no responsibility for the content you choose to view.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;